import pxToRem from "../../functions/pxToRem";

export default function select({ colors, borders }) {
  const { transparent, info, grey } = colors;
  const { borderRadius } = borders;

  const select = {
    styleOverrides: {
      select: {
        display: "flex",
        alignItems: "center",
        padding: `${pxToRem(12)} ${pxToRem(14)} !important`,
        paddingRight: `${pxToRem(32)} !important`,
        minHeight: pxToRem(20),

        "& .Mui-selected": {
          backgroundColor: transparent.main,
        },

        "&:focus": {
          backgroundColor: transparent.main,
          borderRadius: borderRadius.md,
        },
      },

      selectMenu: {
        background: "none",
        height: "auto",
        minHeight: pxToRem(20),
        overflow: "unset",
      },

      icon: {
        display: "block",
        right: pxToRem(12),
        top: "50%",
        transform: "translateY(-50%)",
        color: grey[600],
        transition: "transform 200ms ease-in-out, color 200ms ease-in-out",

        "&.MuiSelect-iconOpen": {
          transform: "translateY(-50%) rotate(180deg)",
          color: info.main,
        },
      },

      outlined: {
        "&:hover ~ .MuiOutlinedInput-notchedOutline": {
          borderColor: grey[400],
        },
      },
    },
  };

  return select;
}
